import { keepPreviousData, queryOptions, skipToken } from '@tanstack/react-query'
import { keys } from './keys'
import {
  fetchCameraStreams,
  fetchStoreCamera,
  fetchStoreCameraConfig,
  fetchStoreCameras,
  fetchStores,
  fetchStoresAuthed,
} from './stores.queries'

export const getStoresOptions = () =>
  queryOptions({
    queryKey: keys.stores.list(),
    queryFn: fetchStores,
  })

export const getBoutiquesOptions = () =>
  queryOptions({
    ...getStoresOptions(),
    select: (data) =>
      data.filter((store) => store.storeType === 'BOUTIQUE' || store.storeType === 'REMOTE'),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60, // 5 minutes
  })

// Boutiques adressables (back-office admin) : liste AUTHENTIFIÉE incluant le store REMOTE
// « Distanciel » + les boutiques non-online, avec labels complets. À utiliser là où un admin doit
// pouvoir affecter n'importe quelle boutique (ex. affectations d'un collaborateur). Clé distincte de
// `list` pour ne pas partager le cache du fetch public (non authentifié) qui exclut REMOTE.
export const getAssignableStoresOptions = () =>
  queryOptions({
    queryKey: keys.stores.assignable(),
    queryFn: fetchStoresAuthed,
    // Boutiques ONLINE (statut OPEN) + les boutiques EN PRÉPARATION (PREPARING, adressables avant
    // ouverture pour affecter des collaborateurs et créer des créneaux) + le store REMOTE
    // « Distanciel » (toujours adressable, même non-online). Exclut les boutiques temporaires /
    // fermées (TEMPORARILY_CLOSED, PERMANENTLY_CLOSED) et les WAREHOUSE/SHIPPING.
    select: (data) =>
      data.filter(
        (store) =>
          store.storeType === 'REMOTE' ||
          (store.storeType === 'BOUTIQUE' && (store.isOnline || store.status === 'PREPARING')),
      ),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60, // 5 minutes
  })

export const getWarehousesOptions = () =>
  queryOptions({
    ...getStoresOptions(),
    select: (data) => data.filter((store) => store.storeType === 'WAREHOUSE'),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60,
  })

export const getStoreCameraConfigOptions = (storeId: number | undefined) =>
  queryOptions({
    queryKey: keys.stores.cameraConfig.summary(storeId),
    queryFn: storeId !== undefined ? () => fetchStoreCameraConfig(storeId) : skipToken,
  })

export const getStoreCameraListOptions = (storeId: number | undefined) =>
  queryOptions({
    queryKey: keys.stores.cameraConfig.cameras.list(storeId),
    queryFn: storeId !== undefined ? () => fetchStoreCameras(storeId) : skipToken,
    staleTime: 1000 * 60 * 5,
  })

export const getStoreCameraOptions = (storeId: number | undefined, cameraId: number | undefined) =>
  queryOptions({
    queryKey: keys.stores.cameraConfig.cameras.byId(storeId, cameraId),
    queryFn:
      storeId !== undefined && cameraId !== undefined
        ? () => fetchStoreCamera(storeId, cameraId)
        : skipToken,
  })

export const getCameraStreamOptions = (storeId: number | undefined) =>
  queryOptions({
    queryKey: keys.stores.cameraStream(storeId),
    queryFn: storeId !== undefined ? () => fetchCameraStreams(storeId) : skipToken,
  })
